module.exports = __webpack_public_path__ + "static/media/10.2e9d9a1a.jpg";